// services/ratingService.js
import { api } from "../config/api";

// Busca avaliações do usuário atual
export const getMyRatings = async () => {
    try {
        const userId = localStorage.getItem("userId");
        const response = await api.get(`/Evaluations/user/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar avaliações:", error);
        return [];
    }
};

// Busca avaliações de um usuário específico
export const getUserEvaluations = async (userId) => {
    try {
        const response = await api.get(`/Evaluations/user/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar avaliações do usuário:", error);
        return [];
    }
};

// Busca resumo das avaliações (média, total, etc)
export const getEvaluationSummary = async (userId) => {
    try {
        const response = await api.get(`/Evaluations/user/${userId}/summary`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar resumo das avaliações:", error);
        return null;
    }
};

// Envia uma avaliação
export const submitEvaluation = async (jobApplicationId, rating, comment) => {
    const response = await api.post(
        `/Evaluations/${jobApplicationId}`,
        { rating, comment }
    );
    return response.data;
};